import { v4 as uuidv4 } from 'uuid';
import { ActRejectionItem, ActRejectionItemGridPluginSettings } from '.';
import i18n from '../../../../i18n';
import { CreateVariant } from '../../../MasterTabsProvider';


export const ActRejectionItemTab = (
    variant: CreateVariant | undefined,
    idGlobal: string,
    parentCallback?: <T>(message: T) => void,
    mnemocode?: string
): ITab => {

    const titleTab = mnemocode 
        ? `${i18n.t("documents.actRejection.actRejectionItemsPositionTabTitle")}: ${mnemocode}` 
        : i18n.t("documents.actRejection.actRejectionItemsPositionTabTitle");
    const titleId = idGlobal !== undefined ? idGlobal : uuidv4();
    
    return {
        id: titleId,
        title: titleTab,
        plugin: "act_rejection_creator_plugin",
        mnemocode: mnemocode,
        view: {
            content: ActRejectionItemGridPluginSettings
                ? <ActRejectionItem
                    gridId={uuidv4()}
                    plugin={ActRejectionItemGridPluginSettings()}
                    idGlobal={idGlobal}
                    variant={variant}
                    data={{ idGlobal, mnemocode }}
                    parentCallback={parentCallback}
                />
                : <p> {i18n.t("general.directoryNotConfigured")} </p>
        }
    }
}

export default ActRejectionItemTab